import React from "react"
import PropTypes from "prop-types"
import MeetingButtonSection from './MeetingButtonSection'
import MeetingSchedule from './MeetingSchedule'
import MeetingStatusSection from './MeetingStatusSection'
import MeetingUserImage from './MeetingUserImage'
import Icon from '../app_components/Icon'
import { semantic } from '@lexody/design-tokens'
import { formatLexTime } from '../utils/lexTime'

function splitAddress(address) {
  if (!address) return { line1: null, line2: null }
  const parts = address.split(',').map((part) => part.trim())
  if (parts.length <= 1) return { line1: address, line2: null }
  return { line1: parts[0], line2: parts.slice(1).join(', ') }
}

class MeetingListItem extends React.Component {
  constructor(props) {
    super(props)

    this.renderMeetingImage = this.renderMeetingImage.bind(this)
    this.renderMeetingItem = this.renderMeetingItem.bind(this)
    this.handleMenuClick = this.handleMenuClick.bind(this)

    this.buttonSectionRef = null

    this.state = {
      otherUser: [],
      currentUser: [],
    }
  }

  componentDidMount() {
    if(this.props.item.requestee.id === this.props.currentUser.id) {
      this.setState({
        otherUser: this.props.item.requestor,
        currentUser: this.props.item.requestee
      })
    } else {
      this.setState({
        otherUser: this.props.item.requestee,
        currentUser: this.props.item.requestor
      })
    }
  }

  handleMenuClick() {
    if (this.buttonSectionRef && this.buttonSectionRef.openChange) {
      this.buttonSectionRef.openChange()
    }
  }

  renderMeetingImage() {
    if(this.state.otherUser !== []) {
      return(
        <div className="upcomingLexCard__avatars">
          <MeetingUserImage otherUser={this.state.otherUser} />
          <span className="upcomingLexCard__exchangeIcon" aria-hidden="true">
            <Icon
              name="exchange-alt"
              size={24}
              color={semantic.primary.surface.default}
            />
          </span>
          <MeetingUserImage otherUser={this.state.currentUser} />
        </div>
      )
    }
  }

  renderMeetingItem() {
    const { meeting_time, location, location_address, lang_one, lang_two, id, status } = this.props.item
    const address = splitAddress(location_address)
    const showActions = status === "Active" && this.props.passed != true

    if(this.props.currentUser) {
      return(
        <article className="upcomingLexCard" key={id}>
          <div className="upcomingLexCard__header">
            <MeetingStatusSection
              item={this.props.item}
              currentUser={this.props.currentUser}
            />
            {showActions &&
              <button
                type="button"
                className="upcomingLexCard__menuBtn"
                aria-label="Meeting options"
                onClick={this.handleMenuClick}
              >
                <Icon name="ellipsis-h" size={20} color={semantic.greyscale.text.subtitle} />
              </button>
            }
          </div>

          <div className="upcomingLexCard__main">
            <div className="upcomingLexCard__dateBox" aria-hidden="true">
              <span className="upcomingLexCard__dateWeekday">{formatLexTime(meeting_time, "ddd").toUpperCase()}</span>
              <span className="upcomingLexCard__dateDay">{formatLexTime(meeting_time, "D")}</span>
              <span className="upcomingLexCard__dateMonth">{formatLexTime(meeting_time, "MMM").toUpperCase()}</span>
            </div>

            <div className="upcomingLexCard__info">
              <div className="upcomingLexCard__timeRow">
                <span className="upcomingLexCard__infoIcon upcomingLexCard__infoIcon--clock">
                  <Icon name="clock" size={20} color={semantic.primary.surface.default} />
                </span>
                <p className="upcomingLexCard__time">
                  <strong>{formatLexTime(meeting_time, "h:mm A")}</strong>
                </p>
              </div>
              {(location || location_address) &&
                <div className="upcomingLexCard__addressRow">
                  <span className="upcomingLexCard__infoIcon upcomingLexCard__infoIcon--location">
                    <Icon name="map-marker" size={20} color={semantic.success.surface.default} />
                  </span>
                  <div className="upcomingLexCard__addressLines">
                    {location &&
                      <p className="upcomingLexCard__locationName">{location}</p>
                    }
                    {address.line1 &&
                      <p className="upcomingLexCard__addressPrimary">{address.line1}</p>
                    }
                    {address.line2 &&
                      <p className="upcomingLexCard__addressSecondary">{address.line2}</p>
                    }
                  </div>
                </div>
              }
            </div>

            <div className="upcomingLexCard__exchange">
              {this.renderMeetingImage()}
              <MeetingSchedule
                meeting_time={meeting_time}
                lang_one={lang_one}
                lang_two={lang_two}
                currentUser={this.props.currentUser}
              />
            </div>
          </div>

          {showActions &&
            <MeetingButtonSection
              ref={(component) => { this.buttonSectionRef = component }}
              meeting={this.props.item}
              currentUser={this.props.currentUser}
              getAllMeetings={this.props.getAllMeetings}
            />
          }
        </article>
      )
    }
    return null
  }

  render() {
    return (
      <div>
        {this.renderMeetingItem()}
      </div>
    )
  }
}

export default MeetingListItem;
